import { useState, useEffect } from 'react';
import { useApi } from '../../api/hooks/useApi';

interface ModuleResponse {
  id: string;
  title: string;
}

interface ModulesApiResponse {
  response: ModuleResponse[];
}

export function useChapterTitle(courseId?: string, chapterId?: string) {
  const { request } = useApi();
  const [chapterTitle, setChapterTitle] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!courseId || !chapterId) return;

    let cancelled = false;

    async function fetchTitle() {
      setLoading(true);
      try {
        const data = await request<ModulesApiResponse>(`api/courses/${courseId}/modules`);
        const modules = data?.response ?? [];
        const match = modules.find((mod) => mod.id === chapterId);
        if (!cancelled) {
          setChapterTitle(match?.title ?? null);
        }
      } catch {
        // silently fall back to position-based title
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchTitle();
    return () => { cancelled = true; };
  }, [courseId, chapterId]);

  return { chapterTitle, loading };
}
